import { ModelBase } from '../../core/model/model-base';

export class ExecutorWebUser extends ModelBase {
  constructor(dataContext?: any) {
    super();
    if (dataContext) {
      this.id = dataContext.id;
      this.userName = dataContext.userName;
      this.personName = dataContext.personName;
    }
  }

  userName: string;
  personName: string;

  toString() {
    return this.personName?.trim() || this.userName || this.id;
  }
}
